export default {
  jp: {
    title: {
      list: 'サービス一覧',
      add: 'サービス登録',
      detail: 'サービス詳細／変更',
      delete: 'サービス削除',
      setting: '利用設定'
    },
    label: {
      serviceName: 'サービス名',
      serviceDesc: 'サービス説明',
      serviceUrl: 'URL',
      displayOrder: '表示順',
      apikey: 'APIキー',
      apikeyDesc: 'APIキーを更新する'
    },
    ph: {
      serviceNameJp: 'サービス名（日本語）を入力してください',
      serviceNameEn: 'サービス名（英語）を入力してください',
      serviceDscrptnJp: 'サービス説明（日本語）を入力してください',
      serviceDscrptnEn: 'サービス説明（英語）を入力してください',
      serviceUrl: 'URLを入力してください',
      displayOrder: '表示順を入力してください'
    },
    headers: {
      serviceName: 'サービス名',
      groupLargeName: 'グループ大分類',
      groupSmallName: 'グループ小分類',
      displayOrder: '表示順'
    },
    error: {
      serviceId: {
        notExist: '既に削除済みのサービスです。一覧に戻り、最新の情報を確認してください。'
      },
      serviceDelete: {
        used: 'このサービスを利用中のアカウントが存在するため、削除を行うことができません。'
      },
      serviceNameJp: {
        required: 'サービス名（日本語）は入力必須項目です。',
        maxLength: 'サービス名（日本語）は100文字以内で入力してください。'
      },
      serviceNameEn: {
        required: 'サービス名（英語）は入力必須項目です。',
        maxLength: 'サービス名（英語）は100文字以内で入力してください。'
      },
      serviceDscrptnJp: {
        required: 'サービス説明（日本語）は入力必須項目です。',
        maxLength: 'サービス説明（日本語）は1000文字以内で入力してください。'
      },
      serviceDscrptnEn: {
        required: 'サービス説明（英語）は入力必須項目です。',
        maxLength: 'サービス説明（英語）は1000文字以内で入力してください。'
      },
      serviceUrl: {
        required: 'URLは入力必須項目です。',
        invalid: 'URLの書式に誤りがあります。',
        maxLength: 'URLは2000文字以内で入力してください。'
      },
      displayOrder: {
        required: '表示順は入力必須項目です。',
        minNumber: '表示順は0以上の数値で入力してください。'
      },
      useGroupList: {
        required: '利用設定は入力必須項目です。',
        notExist: '既に削除済みのグループです。一覧に戻り、最新の情報を確認してください。'
      }
    },
    button: {
      back: '戻る',
      toAdd: 'サービス追加',
      add: '登録する',
      modify: '変更する',
      delete: 'サービスを削除する'
    },
    desc: {
      list: {
        text1: '一覧のサービス名をクリックすることで編集画面を表示します。'
      },
      delete: {
        text1: 'サービスを削除する場合は、以下のボタンをクリックしてください。'
      }
    }
  },
  en: {
  }

}
